module.exports = __webpack_public_path__ + "img/homelist5.20fa7c20.png";